import { render, staticRenderFns } from "./News2.vue?vue&type=template&id=6df5b3a7"
import script from "./News2.vue?vue&type=script&lang=ts"
export * from "./News2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports